define('lq/events/actions/translationCommand',[
    'lq/events/actions/eventAction'
], function(EventAction) {
    'use strict';
    
    function TranslationCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(TranslationCommand, EventAction);

    TranslationCommand.typeName = 'TranslationCommand';

    TranslationCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    TranslationCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'Translation',
            command: this.eventData.command
        };
    };

    TranslationCommand.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    return TranslationCommand;
});
